import {IModalService, IModalSettings} from "angular-ui-bootstrap";
import {NewsHeadlineViewModel} from "../../models/NewsHeadlineViewModel";
import {NewsItemDialog} from "../../components/news-item-dialog/NewsItemDialogComponent";
import {NewsItemService} from "../items/NewsItemService";

export class NewsItemDialogService {

    public static readonly id = "newsItemDialogService";

    /** @ngInject */
    public constructor(private readonly $uibModal: IModalService,
                       private readonly newsItemService: NewsItemService) {
    }

    public open(headline: NewsHeadlineViewModel) {
        const options: IModalSettings = {
            size: "md",
            component: NewsItemDialog,
            resolve: {
                headline: () => headline,
                story: () => this.newsItemService.story(headline.id)
            }
        };
        this.$uibModal.open(options);
    }
}
